<template>
     <div class="w-100">
        <form  @submit.prevent="submit">
            <div class="input-group mb-3">
                    <input type="text" class="form-control" v-model="form.search"  placeholder="Search" aria-label="Search" aria-describedby="basic-addon2">
                    <div class="input-group-append">
                        <button class="btn btn-outline-secondary" type="submit"><i class="fas fa-search"></i></button>
                    </div>
            </div>
        </form>
    </div>
</template>

<script>
import { reactive } from 'vue'
import { Inertia } from '@inertiajs/inertia'

export default {
    setup() {
    const form = reactive({
      search: null
    })
        function submit() {
            Inertia.get('/search', form)
        }

        return { form, submit }
    },
}
</script>